import { render } from "./terms-and-conditions.vue?vue&type=template&id=44f9d00c&scoped=true"
import script from "./terms-and-conditions.vue?vue&type=script&lang=js"
export * from "./terms-and-conditions.vue?vue&type=script&lang=js"

import "./terms-and-conditions.vue?vue&type=style&index=0&id=44f9d00c&lang=scss&scoped=true"

import exportComponent from "D:\\Cater-Frontend\\cater\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44f9d00c"]])

export default __exports__